import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import { palette } from '../../../../../../../settings/themes/colors';
import { DynamicBlock } from './DynamicBlock';
import { DashboardHelpIcon } from './DashboardHelpIcon';

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 32
  },
  sectionTitle: {
    color: palette.captudataBlue,
    fontFamily: 'Nunito',
    fontSize: 26,
    fontWeight: 900,
    letterSpacing: '0.45px',
    lineHeight: 1
  },
  sectionDescription: {
    color: palette.dimGray,
    fontSize: 14,
    marginTop: 4,
    marginBottom: 8
  }
});

export const DynamicSection = ({ section, blocks }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.header}>
        <Typography variant="h5" className={classes.sectionTitle}>
          {section.title}
        </Typography>
        <DashboardHelpIcon text={section.help} />
      </div>
      {section.description ? <Typography className={classes.sectionDescription}>{section.description}</Typography> : null}
      {(blocks || []).map(block => (
        <DynamicBlock key={block.key} block={block} />
      ))}
    </>
  );
};

DynamicSection.propTypes = {
  section: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    help: PropTypes.string
  }).isRequired,
  blocks: PropTypes.array.isRequired
};
